import { useEffect, useState } from "react";
import CreateFAQModal from "./createFaqModal";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";
import AdminToast from "../../../core/admin/adminToast";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import AdminButton from "../../../core/admin/adminButton";
import AdminEmptyState from "../../../core/admin/adminEmptyState";
import { AdminCount } from "../../../core/admin/adminBadge";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { HelpIcon, PlusLineIcon, SortIcon } from "../../../../img/svg/adminIcons";
import FAQ from "./faq";

export interface IFAQ {
    id: string;
    question: string;
    answer: string;
    display: boolean;
    order: number;
}

export default function AdminFAQs() {

    const [faqs, setFaqs] = useState<IFAQ[]|null>(null);
    const [createModal, setCreateModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [goodToast, setGoodToast] = useState(false);
    const [reorder, setReorder] = useState(false);

    useEffect(() => {
        getFaqs();
        // eslint-disable-next-line
    }, [])

    const finish = () => {
        getFaqs();
        setCreateModal(false);
        setGoodToast(true);
    }

    const refresh = async (faq: IFAQ) => {
        if(!faqs){
            return null;
        }
        setFaqs(prevFaqs => prevFaqs && prevFaqs.map(obj => obj.id === faq.id ? {...faq} : obj));
    }

    const getFaqs = async () => {
        try{
            setLoading(true);
            let docs: IFAQ[] = [];
            const q = collection(db, "faqs");
            const docsSnap = await getDocs(q);
            if(docsSnap.empty){
                setLoading(false);
                return null;
            }
            docsSnap.forEach(doc => {
                docs.push({
                    id: doc.id,
                    question: doc.data().question,
                    answer: doc.data().answer,
                    display: doc.data().display,
                    order: doc.data().order
                })
            })
            setFaqs(docs.sort((a, b) => a.order - b.order));
        }catch(error){
            console.log(error);
        }finally {
            setLoading(false);
        }
    }

    return (
        <AdminPage
            title="FAQs"
            description="Perguntas frequentes exibidas na página pública de FAQ. Novas FAQs são criadas ocultas; ative a visibilidade quando estiverem prontas."
            actions={<AdminButton icon={<PlusLineIcon width="16px" />} onClick={() => setCreateModal(true)}>Criar FAQ</AdminButton>}
        >
            <AdminCard
                title={<>Perguntas {faqs && !loading ? <AdminCount count={faqs.length} /> : null}</>}
                description={reorder ? "Digite a posição de cada FAQ (menor aparece primeiro) e salve individualmente." : undefined}
                actions={
                    faqs && !loading ?
                        reorder ?
                            <AdminButton variant="secondary" onClick={() => setReorder(false)}>Concluir</AdminButton>
                            : <AdminButton variant="secondary" icon={<SortIcon width="16px" />} onClick={() => setReorder(true)}>Reordenar</AdminButton>
                        : null
                }
                bodyClassName="p-3 md:p-4"
            >
                {
                    loading ?
                        <AdminLoading />
                        : !faqs ?
                            <AdminEmptyState icon={<HelpIcon />} title="Nenhuma FAQ encontrada" action={<AdminButton variant="secondary" icon={<PlusLineIcon width="16px" />} onClick={() => setCreateModal(true)}>Criar FAQ</AdminButton>} />
                            :
                            <ul className="flex flex-col gap-3">
                                {
                                    faqs.map((f, i) => (
                                        <FAQ faq={f} goodToast={() => setGoodToast(true)} refresh={refresh} reorder={reorder} key={i} />
                                    ))
                                }
                            </ul>
                }
            </AdminCard>
            {
                createModal ?
                    <CreateFAQModal close={() => setCreateModal(false)} finish={finish}
                    />
                    : null
            }
            <AdminToast toast={goodToast} setToast={setGoodToast} tone="success" message="FAQs atualizados!" />
        </AdminPage>
    )
}
